import * as React from 'react';
import { connect } from 'react-redux';
import { Box, Text, Avatar, ThemeContext } from 'grommet';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import DropMenu from 'granite-admin/core/components/DropMenu';
import CompanyDrop from './components/CompanyDrop';
import ImageView from 'granite-admin/core/components/ImageView';
import * as UserDucks from 'granite-admin/accounts/ducks/user';
import * as OrganisationDucks from 'granite-admin/organisations/ducks/organisations';
const GlobalStyles = createGlobalStyle`
  .user-menu-drop {
    left: auto !important;
    right: ${({
  isCollapsed
}) => `calc(100vw - ${isCollapsed ? '315px)' : '512px)'} !important;`}
  }
  .user-menu-drop-right {
    right: auto !important;
    left: ${({
  isCollapsed
}) => `calc(100vw - ${isCollapsed ? '315px)' : '512px)'} !important;`}
  }
`;
const getOrganisationAvatar = (userProfile, graniteAvatar) => {
  if (Boolean(userProfile) === false) return;
  const {
    profileImage
  } = userProfile;
  return profileImage ? /*#__PURE__*/React.createElement(ImageView, {
    src: profileImage,
    size: "27px",
    rounded: true
  }) : /*#__PURE__*/React.createElement(Avatar, {
    background: graniteAvatar.background ?? 'comp-1',
    size: "29px",
    round: "full"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    size: "small"
  }, userProfile.firstName.charAt(0).toUpperCase()));
};
const UserDropMenu = ({
  userProfile,
  isCollapsed,
  organisations,
  selectedOrganisation,
  sidebarPosition,
  signOut,
  hoverIndicatorOptions
}) => {
  const {
    graniteAvatar = {}
  } = React.useContext(ThemeContext);
  const history = useHistory();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, {
    isCollapsed: isCollapsed
  }), /*#__PURE__*/React.createElement(DropMenu, {
    hoverIndicatorOptions: hoverIndicatorOptions,
    icon: getOrganisationAvatar(userProfile, graniteAvatar),
    isCollapsed: isCollapsed,
    label: /*#__PURE__*/React.createElement(Box, {
      pad: {
        horizontal: 'xxsmall'
      }
    }, /*#__PURE__*/React.createElement(Text, null, userProfile.firstName), /*#__PURE__*/React.createElement(Text, {
      size: "xsmall"
    }, selectedOrganisation.name)),
    dropProps: {
      className: sidebarPosition === 'right' ? 'user-menu-drop-right' : 'user-menu-drop',
      style: {
        backgroundColor: '#fff',
        transition: 'all 0.5s ease 0s',
        borderRadius: '6px',
        boxShadow: 'rgb(0 0 0 / 10%) 0px 4px 17px 6px'
      }
    },
    dropAlign: {
      bottom: 'bottom'
    },
    renderItems: () => /*#__PURE__*/React.createElement(CompanyDrop, {
      history: history,
      signOut: signOut
    })
  }));
};
UserDropMenu.propTypes = {
  userProfile: PropTypes.object,
  isCollapsed: PropTypes.bool,
  sidebarPosition: PropTypes.string,
  organisations: PropTypes.array,
  selectedOrganisation: PropTypes.object
};
const mapStateToProps = state => ({
  userProfile: UserDucks.profile(state),
  organisations: OrganisationDucks.organisations(state),
  selectedOrganisation: OrganisationDucks.selectedOrganisation(state)
});
const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(UserDropMenu);